<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<div
  class="v3-image-upload"
  [class.v3-image-upload--dragging]="isDragging()"
  [class.v3-image-upload--cropping]="isCropping"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <div class="v3-image-upload__header">
    <div class="v3-image-upload__heading">
      <h2 class="v3-image-upload__title subsection-title">{{ title() }}</h2>
      @if (isCropping) {
        <p class="v3-image-upload__description fs-body-s">{{ cropDescription }}</p>
      }
    </div>
    <button
      type="button"
      class="v3-image-upload__close"
      (click)="closeDialog()"
      [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
    >
      <ptl-icon [icon]="LucideX" [size]="'m'"></ptl-icon>
    </button>
  </div>

  <div class="v3-image-upload__body" [class.v3-image-upload__body--crop]="isCropping">
    @if (cropData(); as crop) {
      <ptl-v3-image-cropper
        [data]="crop"
        [cancelLabel]="backLabel"
        (applied)="onCropApplied($event)"
        (cancelled)="onCropCancelled()"
      ></ptl-v3-image-cropper>
    }

    <!-- Hidden rather than removed while cropping: stepping back lands on the same search results. -->
    <div class="v3-image-upload__pane" [class.v3-image-upload__pane--hidden]="isCropping">
      <ptl-v3-unsplash-search [initialPhrase]="initialSearchPhrase" (photoPicked)="onPhotoPicked($event)">
        <ptl-button
          searchAction
          class="v3-image-upload__upload-button"
          data-testid="image-dialog-browse"
          [type]="'primary'"
          [size]="'m'"
          [icon]="LucideUpload"
          [text]="'translations.imageUploadV3.uploadFile' | transloco"
          (clicked)="openFilePicker()"
        ></ptl-button>
      </ptl-v3-unsplash-search>
      <input
        data-testid="image-dialog-file"
        #fileInput
        type="file"
        class="v3-image-upload__file-input"
        [accept]="accept"
        (change)="onFileInputChange($event)"
      />
    </div>
  </div>

  @if (!isCropping) {
    <div class="v3-image-upload__dropzone-area">
      <div class="v3-image-upload__divider fs-body-xs" aria-hidden="true">{{ 'translations.imageUploadV3.or' | transloco }}</div>
      <button type="button" class="v3-image-upload__dropzone" data-testid="image-dialog-dropzone" (click)="openFilePicker()">
        <span class="v3-image-upload__dropzone-icon">
          <ptl-icon [icon]="LucideUpload" [size]="'m'" [color]="'currentColor'"></ptl-icon>
        </span>
        <span class="v3-image-upload__dropzone-text">
          <span class="v3-image-upload__dropzone-title fs-body-m">{{ 'translations.imageUploadV3.dragAndDropHere' | transloco }}</span>
          <span class="v3-image-upload__dropzone-hint fs-body-s">
            {{ 'translations.imageUploadV3.dropHint' | transloco: { maxFileSizeMb: maxFileSizeMb } }}
          </span>
        </span>
      </button>
    </div>
  }

  @if (isDragging()) {
    <div class="v3-image-upload__drop-overlay">
      <span class="v3-image-upload__drop-icon">
        <ptl-icon [icon]="LucideArrowUp" [size]="'l'" [color]="'currentColor'"></ptl-icon>
      </span>
      <p class="v3-image-upload__drop-title fs-body-l bold">{{ 'translations.imageUploadV3.dropTitle' | transloco }}</p>
      <p class="v3-image-upload__drop-hint fs-body-s">
        {{ 'translations.imageUploadV3.dropHint' | transloco: { maxFileSizeMb: maxFileSizeMb } }}
      </p>
    </div>
  }
</div>
